/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LevelOfExperience {
  ZeroYears = "ZeroYears",
  FourYears = "FourYears",
  EightYears = "EightYears",
  TwelveYears = "TwelveYears",
  FifteenYears = "FifteenYears",
}

export const LevelOfExperienceDisplay: Record<LevelOfExperience, string> = {
  [LevelOfExperience.ZeroYears]: "0+ years",
  [LevelOfExperience.FourYears]: "4+ years",
  [LevelOfExperience.EightYears]: "8+ years",
  [LevelOfExperience.TwelveYears]: "12+ years",
  [LevelOfExperience.FifteenYears]: "15+ years",
};
